import { Component, OnChanges, Input, ViewChildren, ElementRef, QueryList, SimpleChanges } from '@angular/core';

import { Subject } from '@custom-types/construction-site';

@Component({
  selector: 'app-construction-site-list',
  templateUrl: './construction-site-list.component.html',
  styleUrls: ['./construction-site-list.component.less']
})
export class ConstructionSiteListComponent implements OnChanges {
  @Input('subjects') subjects: any[] = [];
  @Input('users') projectUsers: any[];
  @ViewChildren('echeanceInput', { read: ElementRef }) echeanceInput: QueryList<ElementRef>;

  filteredSubjects: any[] = [];
  filterEcheance: string[] = [];

  possibleStates = [
    {
      label: 'Action en cours de validation',
      name: 'action_pending'
    },
    {
      label: 'Action validées',
      name: 'action_validated'
    },
    {
      label: 'Action réalisées',
      name: 'action_realised'
    }
  ];

  ngOnChanges(changes: SimpleChanges): void {
    this.filteredSubjects = [...this.subjects];
  }

  checkboxEcheanceClicked() {
    this.filterEcheance = [];

    this.echeanceInput.forEach((chapterInput) => {
      if (chapterInput.nativeElement.checked) {
        this.filterEcheance.push(chapterInput.nativeElement.id);
      }
    });

    this.filter();
  }

  filter() {
    this.filteredSubjects = [];

    this.subjects.forEach((subject: Subject) => {
      if (subject.dates.resolution && this.filterEcheance.includes('action_realised')) {
        this.filteredSubjects.push(subject);
      } else if (
        subject.dates.due &&
        !subject.dates.resolution &&
        this.filterEcheance.includes('action_validated')
      ) {
        this.filteredSubjects.push(subject);
      } else if (
        subject.dates.creation &&
        !subject.dates.due &&
        !subject.dates.resolution &&
        this.filterEcheance.includes('action_pending')
      ) {
        this.filteredSubjects.push(subject);
      }
    });
  }

  getUserRole(user): any {
    if (user && this.projectUsers) {
      const findUser = this.projectUsers.find(i => i.user.id === user.id);
      if (findUser) {
        return findUser.project_role.label;
      }
    }
  }
}
